module.exports = __webpack_public_path__ + "img/6.cad11e7e.png";